var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button is-primary is-large is-fullwidth",class:_vm.classLoading,attrs:{"disabled":_vm.isFetching,"type":"submit"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }